import { assertNever } from '../robowhale/utils/assert-never'
import { UrlParams } from '../url-params/UrlParams'

export const Env = {
	LOCAL: 'local',
	DEV: 'dev',
	PROD: 'prod',
} as const

export type Env = (typeof Env)[keyof typeof Env]

export function isEnv(env: string): env is Env {
	return Object.values(Env).includes(env as Env)
}

export function envToNum(env: Env): number {
	switch (env) {
		case Env.LOCAL:
			return 0
		case Env.DEV:
			return 1
		case Env.PROD:
			return 2
		default:
			assertNever(env, 'Unknown env')
	}
}

export function detectEnv(): Env {
	if (UrlParams.has('env')) {
		let env = UrlParams.get('env')
		let isValidEnv = isEnv(env)
		if (isValidEnv) {
			return env as Env
		}
	}

	let hostname = location.hostname
	if (hostname === 'localhost' || isIpAddress(hostname)) {
		return Env.LOCAL
	}

	let pathname = location.pathname
	if (pathname.includes('develop')) {
		return Env.DEV
	}

	return Env.PROD
}

function isIpAddress(hostname: string) {
	return /(\d+)\.(\d+)\.(\d+)\.(\d+)/.test(hostname)
}
